<template>
  <div class="select-video">
    <video class="video" :src="value" controls="controls" v-if="value">
      您的浏览器不支持 video 标签。
    </video>
    <el-input placeholder="资源链接" :value="value" style="width:500px;" @input="change">
      <!-- <el-upload
        slot="append"
        :action="this.$store.state.baseurl+'/audio'"
        :show-file-list="false"
        :multiple="false"
        :headers="headers"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        accept="audio/*"
        :before-upload="beforeUpload"
        name="audio">
        <el-button size="small">上传音乐文件</el-button>
      </el-upload> -->
      <el-button slot="append" size="small" @click="showMaskLayer=true">选择视频</el-button>
    </el-input>
    <mask-layer v-model="showMaskLayer">
      <div class="content">
        <el-upload
          class="upload-content"
          :action="this.$store.state.baseurl+'/video'"
          :show-file-list="false"
          :multiple="false"
          :headers="headers"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          accept="video/*"
          :before-upload="beforeUpload"
          name="video">
          <div class="upload-btn">上传视频</div>
        </el-upload>
        <template v-if="history.length>0">
          <h3 class="title">从上传列表中选择</h3>
          <div class="list-item" v-for="(item,index) in history" :key="index" @click="selected(item.url)">
            <p class="name"><span>文件名称: </span>{{item.name}}</p>
            <p class="others">
              <span class="time"><span class="small gray">上传时间: </span>{{item.time}}</span>
              <span class="size"><span class="small gray">大小: </span>{{item.size}}MB</span>
            </p>
          </div>
        </template>
      </div>
    </mask-layer>
  </div>
</template>
<script>
import MaskLayer from '@/components/MaskLayer'
import { getToken, setStorage, getStorage } from '@/utils/auth'
export default {
  name: 'SelectVideo',
  components: {
    MaskLayer
  },
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
      headers: {
        Authorization: getToken()
      },
      showMaskLayer: false,
      key: 'video',
      history: []
    }
  },
  mounted () {
    let history = getStorage(this.key)
    if (history) {
      this.history = JSON.parse(history)
    }
  },
  methods: {
    change (e) {
      this.$emit('input', e)
    },
    uploadSuccess (response, file, fileList) {
      this.$myLoading.hide()
      this.history.push({
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2),
        time: this.dateFormat(new Date()),
        url: response.data.video.url
      })
      setStorage(this.key, this.history)
      this.selected(response.data.video.url)
    },
    uploadError (e) {
      this.$myLoading.hide()
      this.$message.error('上传失败，网络不佳!')
    },
    beforeUpload (file) {
      this.$myLoading.show('上传中')
    },
    selected (url) {
      this.$emit('input', url)
      this.showMaskLayer = false
    },
    dateFormat (date) {
      function fillNumber (num) {
        if (num < 10) {
          return '0' + num
        } else {
          return num
        }
      }
      return date.getFullYear() + '-' + fillNumber(date.getMonth() + 1) + '-' +
      fillNumber(date.getDate()) + ' ' + fillNumber(date.getHours()) + ':' +
      fillNumber(date.getMinutes()) + ':' + fillNumber(date.getSeconds())
    }
  }
}
</script>
<style lang="less" scoped>
.video {
  width: auto;
  height: 100px;
}
.content {
  width: 700px;
  padding: 50px!important;
  .title {
    text-align: center;
    line-height: 45px;
  }
  .list-item {
    height: 60px;
    margin-bottom: 10px;
    padding: 0 5px;
    color: #555555;
    border-bottom: 1px dashed #dddddd;
    cursor: pointer;
    &:hover {
      background-color: #EBEEF5;
    }
    .name {
      font-size: 18px;
    }
    .others {
      font-size: 14px;
      line-height: 20px;
      display: flex;
      .size {
        margin-left: 40px;
      }
    }
  }
  .upload-content {
    width: 100%;
  }
  .upload-btn {
    width: 700px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border: 1px dashed #dddddd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectVideo/SelectVideo.vue